// @flow

import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import {
  actions as routerActions,
} from 'redux-router5'

import {placeSelectors} from '../../state/place/selectors'
import {mapSelectors} from '../../state/map/selectors'

import {withTranslate} from '../../view/translation'

import './place-list.css'

type Props = {
  places: PlaceDetail[],
  city: ?City,
  cityUrl: ?Url,
  page: ?string,
  count: number,
  cityReady: boolean,
  nextPage: ?Url,
  prevPage: ?Url,
  t: Function,
  onClickPlace: (place: PlaceDetail) => void,
}
class PlaceList extends PureComponent<Props> {

  render() {
    const {places, city, count, cityUrl, cityReady, onClickPlace, t, page, nextPage, prevPage} = this.props
    let isBangkok = true
    if (city) {
      isBangkok = city.name_en === 'Bangkok'
    }

    const districtLabel = isBangkok ? 'PlaceList.area': 'PlaceList.district'
    
    let currentPage = parseInt(page, 10)
    if (!currentPage) {
      currentPage = 1 
    }
    const totalPage = Math.ceil(count/10)
    return(
      <div className="place-list">
        {cityReady && (
          <h3>{t('PlaceList.title')}
            <span>{t('PlaceList.city', {city: city ? city.name: t('Unknow')})}</span>
          </h3>
        )}
        {cityReady && (
          <h3><span>{t('PlaceList.count', {count: count})}</span></h3>
        )}
        <div className="paging">
          <div>
            {prevPage && (
              <a href={`/place-list?city=${cityUrl? cityUrl: ''}&page=${currentPage - 1}`} className="button is-small prev">prev</a>
            )}
          </div>
          <div className="page">{totalPage > 1 && (
            <span>{`${currentPage}/${totalPage}`}</span>
          )}</div>
          <div className="next">
            {nextPage && (
              <a href={`/place-list?city=${cityUrl? cityUrl: ''}&page=${currentPage + 1}`} className="button is-small">next</a>
            )}
          </div>
        </div>
        <div className="place-item-container">
          {places.map((p, index) => {
            return (
              <div key={index}
                className="place-item"
                onClick={() => {onClickPlace(p)}}
              >
                <div>{p.name}</div>
                {p.district && (
                  <div className="place-sub-item">{t(districtLabel, {district: p.district.name})}</div>
                )}
              </div>
            )
          })}
        </div>
        <div className="paging">
          <div>
            {prevPage && (
              <a href={`/place-list?city=${cityUrl? cityUrl: ''}&page=${currentPage - 1}`} className="button is-small prev">prev</a>
            )}
          </div>
          <div className="page">{totalPage > 1 && (
            <span>{`${currentPage}/${totalPage}`}</span>
          )}</div>
          <div className="next">
            {nextPage && (
              <a href={`/place-list?city=${cityUrl? cityUrl: ''}&page=${currentPage + 1}`} className="button is-small">next</a>
            )}
          </div>
        </div>
        {cityReady && places.length === 0 && (
          <h4>{t('PlaceList.emptyPlace')}</h4>
        )}
      </div> 
    )
  }
}

const mapStateToProps = (state:any):any => {
  const cityUrl: ?Url = state.router.route.params.city
  return {
    places: placeSelectors.getPlaceDetailList(state),
    city: mapSelectors.getCityByUrl(state, cityUrl),
    cityReady: mapSelectors.getCities(state).length > 0,
    nextPage: placeSelectors.getNextPage(state),
    prevPage: placeSelectors.getPrevPage(state),
    page: state.router.route.params.page,
    count: placeSelectors.getPlaceCount(state),
    cityUrl,
  }
}

const mapDispatchToProps = (dispatch: Function):any => {
  return {
    onClickPlace: (place:PlaceDetail) => {
      dispatch(routerActions.navigateTo('place-detail', {place: place._links.self}))
    }
  }
}

export default withTranslate(connect(mapStateToProps, mapDispatchToProps)(PlaceList))